import React, { PureComponent, PropTypes } from 'react'
import { connect } from 'react-redux'
import { intlShape } from 'react-intl'

import * as selectors from './loaderSelector'

class Loader extends PureComponent {

	render() {
		if (this.props.loading) {
			return (
				<div className="loading-container">
					<div className="pct pct-loader spinner c2" />
				</div>
			)
		}
		return {...this.props.children}
	}

}

Loader.propTypes = {
	loading: PropTypes.bool
}

Loader.contextTypes = {
	intl: intlShape
}

const mapStateToProps = (state) => ({
	loading: selectors.isLoading(state)
})

export default connect(mapStateToProps)(Loader)



// WEBPACK FOOTER //
// ./src/components/loader/Loader.jsx